<script>
    export let title;
    export let hint;
</script>
<div class="title">
    <h2>{title}</h2>
    <small class="hint">{hint}</small>
</div>
<style>
    .title {
        text-align: center;
    }

    h2 {
        margin: 0;
        font-size: 20px;
        line-height: 28px;
        color: #010101;
    }

    .hint {
        margin-top: 8px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #747474;
    }
</style>
